module.exports = __webpack_public_path__ + "static/media/temple.88351d49.jpg";